
    import '/opt/buildhome/repo/packages/x/components/file-card/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["file-card-demo-basic","file-card-demo-size","file-card-demo-image","file-card-demo-audio","file-card-demo-mask","file-card-demo-icon","file-card-demo-list","file-card-demo-overflow","file-card-demo-_semantic","file-card-demo-_semantic-list"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/file-card/index.en-US.md?type=demo')
};